// extracted by mini-css-extract-plugin
export var active = "_9n-d";
export var blink = "_9n-e";
export var container = "_9n-5";
export var controls = "_9n-0";
export var controlsRight = "_9n-1";
export var fakeCursor = "_9n-c";
export var hidden = "_9n-b";
export var quillContainerSmall = "_9n-7";
export var quillEditor = "_9n-6";
export var quillEditorSmall = "_9n-8";
export var quillFormatButtons = "_9n-a";
export var quillToolbar = "_9n-9";
export var removePadding = "_9n-2";
export var state = "_9n-3";
export var stateTitle = "_9n-4";